import { render, staticRenderFns } from "./Iopen.vue?vue&type=template&id=d1732490&"
import script from "./Iopen.vue?vue&type=script&lang=js&"
export * from "./Iopen.vue?vue&type=script&lang=js&"
import style0 from "./Iopen.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports